export default "__VITE_ASSET__ClQjIR$9__"